// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","800":"boards"}[chunkId] + "." + {"594":"a35564af","800":"8a80c0d2"}[chunkId] + ".css";
};